module.exports = __webpack_public_path__ + "img/mdh4.b283b8d5.jpg";